import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { OptionSelect } from 'admin/views/site-designer/modules/sections/components/ContentCollectionsOption';
import { getSitePagesWithSection } from 'admin/api/AuthApi';
import { useSelector } from 'react-redux';
import {
   pagesListSelector,
} from 'admin/state/modules/site-designer/selectors';

const ContentLinkToSelectSection = ({
   value,
   contentLibraryType,
   onChange,
   name,
}) => {
   const [isOpenSelect, setIsOpenSelect] = useState(false);
   const pagesList = useSelector(pagesListSelector)

   const [data, setData] = useState([]);
   const [isFetching, setIsFetching] = useState(false);
   const [selectPage, setSelectedPage] = useState({});


   useEffect(() => {
      setData([])
      setIsFetching(false)
   }, [contentLibraryType])

   const fetchData = async () => {
      setIsFetching(true);
      try {
         const { data } = await getSitePagesWithSection(contentLibraryType);
         setData(data);
         setIsFetching(false);
      } catch (error) {
         setIsFetching(false);
      }
   }
   useEffect(() => {
      if(value){
         const page = [...pagesList].find(page => page.content_mapping_id === value) || {};
         setSelectedPage(page);
      }
   // eslint-disable-next-line react-hooks/exhaustive-deps
   }, [])

   return (
      <OptionSelect
         tooltipId={ 'tooltipId' }
         onClick={ () => {
            setIsOpenSelect(!isOpenSelect)
            if(!data?.length){
               fetchData();
            }
         } }
         selectText='Select'
         isOpenSelect={ isOpenSelect }
         isFetching={ isFetching }
         options={ data }
         width='305px'
         activeValue={ { ...selectPage, value: selectPage?.content_mapping_id } }
         onChange={ (page) => {
            onChange(name, page.content_mapping_id);
            setSelectedPage(page);
         } }
         valueKey='content_mapping_id'
      />
   );
};


ContentLinkToSelectSection.propTypes = {
   value: PropTypes.string,
   name: PropTypes.string,
   onChange: PropTypes.func,
   contentLibraryType: PropTypes.oneOf([
      'video_library', 'recorded_livestreams_library', 'photoset_library', 'store', 'stories_library',
   ]),
};

export default ContentLinkToSelectSection;
